<template>
  <div ref="player"></div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    if (typeof window.YT === 'undefined' || typeof window.YT.Player === 'undefined') {
      // If the YouTube iFrame API is not yet loaded, wait for it to load
      window.onYouTubeIframeAPIReady = () => {
        this.createPlayer();
      };
    } else {
      // If the YouTube iFrame API is already loaded, create the player immediately
      this.createPlayer();
    }
  },
  methods: {
    createPlayer() {
      // create the YouTube player
      this.player = new window.YT.Player(this.$refs.player, {
        videoId: this.videoId,
        playerVars: {
          controls: 0,
          modestbranding: 1,
          showinfo: 0,
        },
      });
    },
  },
  beforeUnmount() {
    // destroy the YouTube player when the component is destroyed
    if (this.player !== null) {
      this.player.destroy();
    }
  },
};
</script>
